// extracted by mini-css-extract-plugin
export var parcelRow = "_tv-0";